import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "@/lib/scroll";
import site from "@/data/site.json";

const EASE = [0.22, 1, 0.36, 1];

export default function MobileMenu({ open, onClose }) {
    const go = (id) => {
        onClose();
        setTimeout(() => scrollToId(id), 60);
    };

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    data-testid="mobile-menu"
                    className="fixed inset-0 z-50 flex flex-col bg-forest lg:hidden"
                    initial={{ opacity: 0, clipPath: "circle(0% at 92% 6%)" }}
                    animate={{ opacity: 1, clipPath: "circle(140% at 92% 6%)" }}
                    exit={{ opacity: 0, clipPath: "circle(0% at 92% 6%)" }}
                    transition={{ duration: 0.55, ease: EASE }}
                >
                    <div className="container-x flex h-16 items-center justify-between">
                        <Logo light />
                        <button
                            type="button"
                            data-testid="menu-close-button"
                            onClick={onClose}
                            aria-label="Fechar menu"
                            className="grid h-11 w-11 place-items-center rounded-full border border-cream/20 text-cream transition-colors hover:bg-cream/10"
                        >
                            <X className="h-5 w-5" />
                        </button>
                    </div>

                    <nav className="container-x mt-6 flex flex-1 flex-col justify-center gap-1" aria-label="Menu móvel">
                        {site.nav.map((item, i) => (
                            <motion.button
                                key={item.id}
                                type="button"
                                data-testid={`mobile-nav-link-${item.id}`}
                                onClick={() => go(item.id)}
                                initial={{ opacity: 0, x: -28 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.15 + i * 0.055, duration: 0.5, ease: EASE }}
                                className="group flex items-baseline gap-4 py-2 text-left"
                            >
                                <span className="text-xs font-bold text-coral">0{i + 1}</span>
                                <span className="font-serif text-3xl font-semibold text-cream transition-colors group-hover:text-coral">
                                    {item.label}
                                </span>
                            </motion.button>
                        ))}
                    </nav>

                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.55, duration: 0.5, ease: EASE }}
                        className="container-x pb-10"
                    >
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-cream/50">
                            {site.contact.whatsappLabel} · demonstrativo
                        </p>
                        <p className="mt-2 text-xs text-cream/40">{site.brand.notice}</p>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
